import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass } from "vue";
import _imports_0 from '@/assets/icon-real.png';
var _hoisted_1 = {
  style: {
    "display": "flex",
    "overflow": "auto"
  }
};
var _hoisted_2 = {
  style: {
    "flex": "1",
    "border-right": "1px solid #eee",
    "padding": "0px",
    "overflow": "auto",
    "display": "flex",
    "flex-direction": "column"
  }
};
var _hoisted_3 = {
  style: {
    "flex": "1",
    "overflow": "auto",
    "position": "relative"
  }
};
var _hoisted_4 = {
  key: 0
};
var _hoisted_5 = {
  key: 0,
  class: "scale-controls"
};
var _hoisted_6 = {
  style: {
    "margin": "0 10px"
  }
};
var _hoisted_7 = {
  key: 0,
  class: "pdf-container"
};
var _hoisted_8 = {
  key: 0,
  class: "pagination"
};
var _hoisted_9 = {
  style: {
    "margin": "0 15px"
  }
};
var _hoisted_10 = {
  key: 3,
  style: {
    "width": "100%",
    "height": "100%",
    "display": "flex",
    "align-items": "center",
    "justify-content": "center"
  }
};
var _hoisted_11 = ["src"];
var _hoisted_12 = {
  key: 4,
  style: {
    "text-align": "center",
    "padding": "50px"
  }
};
var _hoisted_13 = {
  key: 1,
  style: {
    "text-align": "center",
    "padding": "50px"
  }
};
var _hoisted_14 = {
  key: 1,
  style: {
    "text-align": "center",
    "width": "100%",
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "center",
    "height": "100%"
  }
};
var _hoisted_15 = {
  key: 2,
  style: {
    "text-align": "center",
    "color": "#999",
    "display": "flex",
    "align-items": "center",
    "justify-content": "center",
    "height": "100%"
  }
};
var _hoisted_16 = {
  style: {
    "width": "500px",
    "padding": "20px",
    "overflow": "auto"
  }
};
var _hoisted_17 = {
  key: 0,
  class: "horizontal-step-container"
};
var _hoisted_18 = {
  class: "step-progress-bar"
};
var _hoisted_19 = {
  class: "step-content"
};
var _hoisted_20 = {
  class: "step-icon"
};
var _hoisted_21 = {
  class: "step-label"
};
var _hoisted_22 = {
  class: "invoice-info"
};
var _hoisted_23 = {
  class: "invoice-info"
};
var _hoisted_24 = {
  class: "invoice-info"
};
var _hoisted_25 = {
  class: "invoice-info"
};
var _hoisted_26 = {
  class: "invoice-info"
};
var _hoisted_27 = {
  class: "invoice-info"
};
var _hoisted_28 = {
  class: "invoice-info"
};
var _hoisted_29 = {
  class: "invoice-info"
};
var _hoisted_30 = {
  class: "invoice-info"
};
var _hoisted_31 = {
  class: "invoice-info"
};
var _hoisted_32 = {
  class: "invoice-info"
};
var _hoisted_33 = {
  class: "invoice-info"
};
var _hoisted_34 = {
  class: "invoice-info"
};
var _hoisted_35 = {
  class: "dialog-footer"
};
var _hoisted_36 = {
  key: 0,
  style: {
    "position": "absolute",
    "bottom": "15px",
    "left": "30%",
    "transform": "translateX(-50%)",
    "z-index": "10",
    "background": "rgba(0, 0, 0, 0.6)",
    "padding": "5px 15px",
    "border-radius": "20px",
    "display": "flex",
    "align-items": "center"
  }
};
var _hoisted_37 = {
  style: {
    "color": "white",
    "margin": "0 10px"
  }
};
import { ref, computed, watch } from "vue";
import { ElMessage } from "element-plus";
import VueOfficePdf from "@vue-office/pdf";
import VueOfficeDocx from "@vue-office/docx";
import VueOfficeExcel from "@vue-office/excel";
import VuePdfEmbed from "vue-pdf-embed";
import "vue-pdf-embed/dist/styles/annotationLayer.css";
import "vue-pdf-embed/dist/styles/textLayer.css";
// import * as pdfjsLib from 'pdfjs-dist/build/pdf'

export default {
  __name: 'InvoiceDetailDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    file: {
      type: [Object, Array],
      default: () => ({})
    }
  },
  emits: ["update:modelValue"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var emit = __emit;
    var visible = ref(false);
    var previewLoading = ref(false);
    var currentStep = ref(3);
    var fileList = ref([]); // 存储文件列表
    var currentFileIndex = ref(0); // 当前文件索引
    var currentFile = ref({}); // 当前显示的文件

    var scale = ref(1);

    // 当前文件URL
    var currentFileUrl = computed(() => {
      if (fileList.value.length > 0 && currentFileIndex.value < fileList.value.length) {
        return fileList.value[currentFileIndex.value].url;
      }
      return "";
    });

    // 当前文件类型
    var currentFileType = computed(() => {
      if (fileList.value.length > 0 && currentFileIndex.value < fileList.value.length) {
        return fileList.value[currentFileIndex.value].type;
      }
      return "";
    });
    watch(() => props.modelValue, val => {
      visible.value = val;
      console.log("file", props.file);
      if (val && props.file) {
        initPreviewFile();
      }
    });
    watch(visible, val => {
      emit("update:modelValue", val);
      if (!val) {
        resetPreview();
      }
    });
    var zoomIn = () => {
      if (scale.value < 2) {
        scale.value = Math.min(2, scale.value + 0.1); // 最大放大到2倍
      }
    };
    var zoomOut = () => {
      if (scale.value > 0.5) {
        scale.value = Math.max(0.5, scale.value - 0.1); // 最小缩小到0.5倍
      }
    };
    var resetZoom = () => {
      scale.value = 1; // 重置为原始大小
    };
    var hasPreviewFile = computed(() => {
      var _props$file;
      if ((_props$file = props.file) !== null && _props$file !== void 0 && _props$file.current) {
        var _props$file$current, _props$file$current2, _props$file$current3;
        // 新的数据结构 {current: ..., list: [...]}
        return !!((_props$file$current = props.file.current) !== null && _props$file$current !== void 0 && _props$file$current.file_url || (_props$file$current2 = props.file.current) !== null && _props$file$current2 !== void 0 && _props$file$current2.url || (_props$file$current3 = props.file.current) !== null && _props$file$current3 !== void 0 && (_props$file$current3 = _props$file$current3.response) !== null && _props$file$current3 !== void 0 && (_props$file$current3 = _props$file$current3.data) !== null && _props$file$current3 !== void 0 && _props$file$current3.file_url);
      } else {
        var _props$file2, _props$file3, _props$file4;
        // 旧的数据结构，单个文件对象
        return !!((_props$file2 = props.file) !== null && _props$file2 !== void 0 && _props$file2.file_url || (_props$file3 = props.file) !== null && _props$file3 !== void 0 && _props$file3.url || (_props$file4 = props.file) !== null && _props$file4 !== void 0 && (_props$file4 = _props$file4.response) !== null && _props$file4 !== void 0 && (_props$file4 = _props$file4.data) !== null && _props$file4 !== void 0 && _props$file4.file_url);
      }
    });
    var initPreviewFile = () => {
      var _props$file5;
      // 处理新的数据结构 {current: ..., list: [...]}
      if ((_props$file5 = props.file) !== null && _props$file5 !== void 0 && _props$file5.list && Array.isArray(props.file.list)) {
        currentFile.value = props.file.current;

        // 处理文件列表
        fileList.value = props.file.list.map(f => {
          var _f$response;
          var url = ((_f$response = f.response) === null || _f$response === void 0 ? void 0 : _f$response.data.file_url) || f.url || f.file_url;
          var fileName = f.file_name || f.name;
          return {
            url,
            fileName,
            type: (fileName === null || fileName === void 0 ? void 0 : fileName.split(".").pop().toLowerCase()) || "",
            data: f // 保存原始数据用于显示发票信息
          };
        }).filter(f => f.url); // 过滤掉无效URL

        // 找到当前文件的索引
        var currentIndex = fileList.value.findIndex(f => f.data === props.file.current);
        currentFileIndex.value = currentIndex >= 0 ? currentIndex : 0;
      }
      // 处理数组数据结构
      else if (Array.isArray(props.file)) {
        fileList.value = props.file.map(f => {
          var _f$response2;
          var url = ((_f$response2 = f.response) === null || _f$response2 === void 0 ? void 0 : _f$response2.data.file_url) || f.url || f.file_url;
          var fileName = f.file_name || f.name;
          return {
            url,
            fileName,
            type: (fileName === null || fileName === void 0 ? void 0 : fileName.split(".").pop().toLowerCase()) || "",
            data: f
          };
        }).filter(f => f.url); // 过滤掉无效URL

        currentFileIndex.value = 0;
        if (fileList.value.length > 0) {
          currentFile.value = fileList.value[0].data;
        }
      }
      // 处理单个文件对象
      else {
        var _file$response;
        var file = props.file;
        var url = ((_file$response = file.response) === null || _file$response === void 0 ? void 0 : _file$response.data.file_url) || file.url || file.file_url;
        var fileName = file.file_name || file.name;
        if (url) {
          fileList.value = [{
            url,
            fileName,
            type: (fileName === null || fileName === void 0 ? void 0 : fileName.split(".").pop().toLowerCase()) || "",
            data: file
          }];
          currentFile.value = file;
          currentFileIndex.value = 0;
        } else {
          fileList.value = [];
          currentFile.value = {};
          currentFileIndex.value = 0;
        }
      }
      console.log("currentFile----->", currentFile.value);
      previewLoading.value = false;
    };
    var isCurrentFileType = types => {
      if (Array.isArray(types)) {
        return types.includes(currentFileType.value);
      }
      return currentFileType.value === types;
    };
    var onPreviewRendered = () => {
      previewLoading.value = false;
    };
    var onPreviewError = error => {
      previewLoading.value = false;
      ElMessage({
        type: "error",
        message: "文件预览失败: " + (error.message || "未知错误")
      });
    };
    var openFile = () => {
      var _currentFile$value, _currentFile$value2, _currentFile$value3;
      var url = ((_currentFile$value = currentFile.value) === null || _currentFile$value === void 0 || (_currentFile$value = _currentFile$value.response) === null || _currentFile$value === void 0 || (_currentFile$value = _currentFile$value.data) === null || _currentFile$value === void 0 ? void 0 : _currentFile$value.file_url) || ((_currentFile$value2 = currentFile.value) === null || _currentFile$value2 === void 0 ? void 0 : _currentFile$value2.url) || ((_currentFile$value3 = currentFile.value) === null || _currentFile$value3 === void 0 ? void 0 : _currentFile$value3.file_url);
      if (url) {
        window.open(url, "_blank");
      } else {
        ElMessage.warning("无法打开该文件");
      }
    };
    var closeDialog = () => {
      visible.value = false;
    };
    var resetPreview = () => {
      fileList.value = [];
      currentFileIndex.value = 0;
      currentFile.value = {};
      previewLoading.value = false;
    };

    // 步骤条数据
    var steps = ref([{
      title: "智能识别",
      icon: "CircleCheck"
    }, {
      title: "无重复提交",
      icon: "CircleCheck"
    }, {
      title: "发票为真",
      icon: "CircleCheck"
    }]);
    var currentPage = ref(1);
    var totalPages = ref(0);
    var onPdfLoaded = pdf => {
      console.log({
        pdf
      });
      totalPages.value = pdf.numPages;
    };
    var prevPage = () => {
      if (currentPage.value > 1) currentPage.value--;
    };
    var nextPage = () => {
      if (currentPage.value < totalPages.value) currentPage.value++;
    };
    var handlePreview = url => {
      if (url) {
        ElMessage({
          type: "success",
          message: "正在导出，请稍候"
        });
        var eleLink = document.createElement("a");
        eleLink.href = url;
        eleLink.target = "_blank";
        document.body.appendChild(eleLink);
        eleLink.click();
        document.body.removeChild(eleLink);
      } else {
        ElMessage.warning("无法预览该文件");
      }
    };

    // 上一个文件
    var prevFile = () => {
      if (currentFileIndex.value > 0) {
        currentFileIndex.value--;
        updateCurrentFile();
      }
    };

    // 下一个文件
    var nextFile = () => {
      if (currentFileIndex.value < fileList.value.length - 1) {
        currentFileIndex.value++;
        updateCurrentFile();
      } else if (fileList.value.length > 1) {
        // 循环到第一个
        currentFileIndex.value = 0;
        updateCurrentFile();
      }
    };

    // 更新当前文件信息
    var updateCurrentFile = () => {
      if (fileList.value.length > 0 && currentFileIndex.value < fileList.value.length) {
        currentFile.value = fileList.value[currentFileIndex.value].data;
      }
    };

    // 打印当前文件
    var printFile = () => {
      var fileType = currentFileType.value;
      var fileUrl = currentFileUrl.value;
      if (!fileUrl) {
        ElMessage.warning("无法打印该文件");
        return;
      }
      if (["jpg", "jpeg", "png", "gif", "bmp", "jfif"].includes(fileType)) {
        // 打印图片
        printImage(fileUrl);
      } else if (fileType === "pdf") {
        // 打印PDF
        printPdf(fileUrl);
      } else {
        ElMessage.warning("该文件类型不支持打印");
      }
    };

    // 打印图片
    var printImage = imageUrl => {
      var printWindow = window.open("", "_blank");
      printWindow.document.write("\n    <html>\n      <head>\n        <title>\u6253\u5370\u56FE\u7247</title>\n        <style>\n          body {\n            margin: 0;\n            padding: 20px;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            min-height: 100vh;\n            background: #f5f5f5;\n          }\n          img {\n            max-width: 100%;\n            max-height: 100vh;\n            box-shadow: 0 0 10px rgba(0,0,0,0.1);\n          }\n        </style>\n      </head>\n      <body>\n        <img src=\"".concat(imageUrl, "\" onload=\"window.print(); window.close();\" />\n      </body>\n    </html>\n  "));
      printWindow.document.close();
    };

    // 打印PDF
    var printPdf = pdfUrl => {
      var printWindow = window.open("", "_blank");
      printWindow.document.write("\n    <html>\n      <head>\n        <title>\u6253\u5370PDF</title>\n        <style>\n          body {\n            margin: 0;\n            padding: 0;\n            background: #f5f5f5;\n          }\n          iframe {\n            width: 100%;\n            height: 100vh;\n            border: none;\n          }\n        </style>\n      </head>\n      <body>\n        <iframe src=\"".concat(pdfUrl, "\" onload=\"this.contentWindow.print();\"></iframe>\n      </body>\n    </html>\n  "));
      printWindow.document.close();
    };
    return (_ctx, _cache) => {
      var _component_el_button = _resolveComponent("el-button");
      var _component_el_icon = _resolveComponent("el-icon");
      var _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: visible.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => visible.value = $event),
        title: "发票详情",
        width: "85%",
        onClose: closeDialog
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_35, [fileList.value.length > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_createVNode(_component_el_button, {
          circle: "",
          icon: "ArrowLeft",
          onClick: prevFile,
          disabled: currentFileIndex.value <= 0
        }, null, 8, ["disabled"]), _createElementVNode("span", _hoisted_37, _toDisplayString(currentFileIndex.value + 1) + " / " + _toDisplayString(fileList.value.length), 1), _createVNode(_component_el_button, {
          circle: "",
          icon: "ArrowRight",
          onClick: nextFile,
          disabled: currentFileIndex.value >= fileList.value.length - 1
        }, null, 8, ["disabled"])])) : _createCommentVNode("", true), isCurrentFileType(['pdf', 'jpg', 'jpeg', 'png', 'gif', 'bmp', 'jfif']) ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          onClick: printFile,
          type: "primary"
        }, {
          default: _withCtx(() => _cache[28] || (_cache[28] = [_createTextVNode("打印")])),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_button, {
          onClick: closeDialog
        }, {
          default: _withCtx(() => _cache[29] || (_cache[29] = [_createTextVNode("关闭")])),
          _: 1
        })])]),
        default: _withCtx(() => {
          var _currentFile$value4;
          return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [hasPreviewFile.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [isCurrentFileType(['pdf', 'docx', 'xls', 'xlsx', 'jpg', 'jpeg', 'png', 'gif', 'bmp', 'jfif']) ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_button, {
            size: "small",
            type: "primary",
            onClick: zoomOut,
            disabled: scale.value <= 0.5
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("缩小")])),
            _: 1
          }, 8, ["disabled"]), _createElementVNode("span", _hoisted_6, _toDisplayString(Math.round(scale.value * 100)) + "%", 1), _createVNode(_component_el_button, {
            size: "small",
            type: "primary",
            onClick: zoomIn,
            disabled: scale.value >= 2
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("放大")])),
            _: 1
          }, 8, ["disabled"]), _createVNode(_component_el_button, {
            size: "small",
            onClick: resetZoom
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("重置")])),
            _: 1
          })])) : _createCommentVNode("", true), _createElementVNode("div", {
            class: "pdf-transform-wrapper",
            style: _normalizeStyle({
              transform: "scale(".concat(scale.value, ")"),
              transformOrigin: 'top center',
              marginBottom: '10px'
            })
          }, [isCurrentFileType('pdf') ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_unref(VuePdfEmbed), {
            onLoaded: onPdfLoaded,
            source: {
              url: currentFileUrl.value,
              cMapUrl: 'https://unpkg.com/pdfjs-dist/cmaps/',
              cMapPacked: true
            }
          }, null, 8, ["source"]), totalPages.value > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_el_button, {
            size: "small",
            type: "primary",
            onClick: prevPage,
            disabled: currentPage.value <= 1
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("上一页")])),
            _: 1
          }, 8, ["disabled"]), _createElementVNode("span", _hoisted_9, _toDisplayString(currentPage.value) + " / " + _toDisplayString(totalPages.value), 1), _createVNode(_component_el_button, {
            size: "small",
            onClick: nextPage,
            type: "primary",
            disabled: currentPage.value >= totalPages.value
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("下一页")])),
            _: 1
          }, 8, ["disabled"])])) : _createCommentVNode("", true)])) : isCurrentFileType(['docx']) ? (_openBlock(), _createBlock(_unref(VueOfficeDocx), {
            key: 1,
            src: currentFileUrl.value,
            style: {
              "width": "100%",
              "height": "100%"
            },
            onRendered: onPreviewRendered,
            onError: onPreviewError
          }, null, 8, ["src"])) : isCurrentFileType(['xls', 'xlsx']) ? (_openBlock(), _createBlock(_unref(VueOfficeExcel), {
            key: 2,
            src: currentFileUrl.value,
            style: {
              "width": "100%",
              "height": "100%"
            },
            onRendered: onPreviewRendered,
            onError: onPreviewError
          }, null, 8, ["src"])) : isCurrentFileType(['jpg', 'jpeg', 'png', 'gif', 'bmp', 'jfif']) ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("img", {
            src: currentFileUrl.value,
            style: {
              "max-width": "100%",
              "max-height": "100%",
              "display": "block",
              "margin": "0 auto",
              "cursor": "pointer"
            },
            onClick: nextFile
          }, null, 8, _hoisted_11)])) : (_openBlock(), _createElementBlock("div", _hoisted_12, [_cache[8] || (_cache[8] = _createElementVNode("p", {
            style: {
              "padding-bottom": "20px"
            }
          }, "该文件类型暂不支持在线预览。", -1)), _createVNode(_component_el_button, {
            onClick: _cache[0] || (_cache[0] = $event => handlePreview(currentFileUrl.value)),
            type: "primary"
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode(" 下载文件 ")])),
            _: 1
          })]))], 4), previewLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_13, _cache[9] || (_cache[9] = [_createElementVNode("p", null, "文件加载中...", -1)]))) : _createCommentVNode("", true)])) : !hasPreviewFile.value && (_currentFile$value4 = currentFile.value) !== null && _currentFile$value4 !== void 0 && _currentFile$value4.file_name ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("p", null, [_cache[10] || (_cache[10] = _createElementVNode("strong", null, "文件名:", -1)), _createTextVNode(" " + _toDisplayString(currentFile.value.file_name), 1)]), _createVNode(_component_el_button, {
            type: "primary",
            onClick: openFile,
            style: {
              "margin-top": "20px",
              "align-self": "center"
            }
          }, {
            default: _withCtx(() => _cache[11] || (_cache[11] = [_createTextVNode(" 打开文件 ")])),
            _: 1
          })])) : (_openBlock(), _createElementBlock("div", _hoisted_15, _cache[12] || (_cache[12] = [_createElementVNode("p", null, "暂无预览", -1)])))])]), _createElementVNode("div", _hoisted_16, [_cache[27] || (_cache[27] = _createElementVNode("h3", {
            style: {
              "text-align": "center",
              "margin": "0 0 10px"
            }
          }, "发票信息", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentFile.value.invoice_list || currentFile.value.data, (v, i) => {
            return _openBlock(), _createElementBlock("div", {
              style: {
                "padding": "50px 20px 0"
              },
              key: i
            }, [(v === null || v === void 0 ? void 0 : v.status) == 4 ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_cache[13] || (_cache[13] = _createElementVNode("div", {
              class: "stamp-container"
            }, [_createElementVNode("div", {
              class: "stamp"
            }, [_createElementVNode("img", {
              class: "stamp-icon",
              src: _imports_0,
              alt: "印章"
            })])], -1)), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", {
              class: "progress-line",
              style: _normalizeStyle({
                width: _ctx.progressWidth
              })
            }, null, 4), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(steps.value, (step, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass(["step-point", {
                  active: currentStep.value >= index,
                  completed: currentStep.value > index
                }])
              }, [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createVNode(_component_el_icon, {
                size: 20
              }, {
                default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(step.icon)))]),
                _: 2
              }, 1024)]), _createElementVNode("div", _hoisted_21, _toDisplayString(step.title), 1)]), index < steps.value.length - 1 ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["step-connector", {
                  active: currentStep.value > index
                }])
              }, null, 2)) : _createCommentVNode("", true)], 2);
            }), 128))])])) : _createCommentVNode("", true), _createElementVNode("p", _hoisted_22, [_cache[14] || (_cache[14] = _createElementVNode("span", null, "购买方：", -1)), _createElementVNode("span", null, _toDisplayString((v === null || v === void 0 ? void 0 : v.buyer) || "--"), 1)]), _createElementVNode("p", _hoisted_23, [_cache[15] || (_cache[15] = _createElementVNode("span", null, "销售方：", -1)), _createElementVNode("span", null, _toDisplayString((v === null || v === void 0 ? void 0 : v.seller) || "--"), 1)]), _createElementVNode("p", _hoisted_24, [_cache[16] || (_cache[16] = _createElementVNode("span", null, "开票日期：", -1)), _createElementVNode("span", null, _toDisplayString((v === null || v === void 0 ? void 0 : v.date) || "--"), 1)]), _createElementVNode("p", _hoisted_25, [_cache[17] || (_cache[17] = _createElementVNode("span", null, "发票号码：", -1)), _createElementVNode("span", null, _toDisplayString((v === null || v === void 0 ? void 0 : v.number) || "--"), 1)]), _createElementVNode("p", _hoisted_26, [_cache[18] || (_cache[18] = _createElementVNode("span", null, "金额：", -1)), _createElementVNode("span", null, _toDisplayString((v === null || v === void 0 ? void 0 : v.total) || "--"), 1)]), _createElementVNode("p", _hoisted_27, [_cache[19] || (_cache[19] = _createElementVNode("span", null, "校验码：", -1)), _createElementVNode("span", null, _toDisplayString((v === null || v === void 0 ? void 0 : v.check_code) || "--"), 1)]), _createElementVNode("p", _hoisted_28, [_cache[20] || (_cache[20] = _createElementVNode("span", null, "购买方税号：", -1)), _createElementVNode("span", null, _toDisplayString((v === null || v === void 0 ? void 0 : v.buyer_tax_id) || "--"), 1)]), _createElementVNode("p", _hoisted_29, [_cache[21] || (_cache[21] = _createElementVNode("span", null, "销售方税号：", -1)), _createElementVNode("span", null, _toDisplayString((v === null || v === void 0 ? void 0 : v.check_code) || "--"), 1)]), _createElementVNode("p", _hoisted_30, [_cache[22] || (_cache[22] = _createElementVNode("span", null, "购买方地址电话：", -1)), _createElementVNode("span", null, _toDisplayString((v === null || v === void 0 ? void 0 : v.buyer_addr_tel) || "--"), 1)]), _createElementVNode("p", _hoisted_31, [_cache[23] || (_cache[23] = _createElementVNode("span", null, "销售方地址电话：", -1)), _createElementVNode("span", null, _toDisplayString((v === null || v === void 0 ? void 0 : v.seller_addr_tel) || "--"), 1)]), _createElementVNode("p", _hoisted_32, [_cache[24] || (_cache[24] = _createElementVNode("span", null, "购买方银行账户：", -1)), _createElementVNode("span", null, _toDisplayString((v === null || v === void 0 ? void 0 : v.seller_bank_account) || "--"), 1)]), _createElementVNode("p", _hoisted_33, [_cache[25] || (_cache[25] = _createElementVNode("span", null, "发票名称：", -1)), _createElementVNode("span", null, _toDisplayString((v === null || v === void 0 ? void 0 : v.name) || "--"), 1)]), _createElementVNode("p", _hoisted_34, [_cache[26] || (_cache[26] = _createElementVNode("span", null, "发票类型：", -1)), _createElementVNode("span", null, _toDisplayString((v === null || v === void 0 ? void 0 : v.subtype_description) || "--"), 1)])]);
          }), 128))])])];
        }),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};